const GET_QRCODE_CLIENT_LOADING = '/GET_QRCODE_CLIENT_LOADING';
const GET_QRCODE_CLIENT_SUCCESS = '/GET_QRCODE_CLIENT_SUCCESS';
const GET_QRCODE_CLIENT_ERROR = '/GET_QRCODE_CLIENT_ERROR';

const POST_QRCODE_LOGIN_LOADING = '/POST_QRCODE_LOGIN_LOADING';
const POST_QRCODE_LOGIN_ERROR = '/POST_QRCODE_LOGIN_ERROR';
const POST_QRCODE_LOGIN_SUCCESS = '/POST_QRCODE_LOGIN_SUCCESS';

export {
  GET_QRCODE_CLIENT_LOADING,
  GET_QRCODE_CLIENT_SUCCESS,
  GET_QRCODE_CLIENT_ERROR,
  POST_QRCODE_LOGIN_LOADING,
  POST_QRCODE_LOGIN_ERROR,
  POST_QRCODE_LOGIN_SUCCESS
};
